import React from 'react';
import BaseComponent, { connect } from '@common/components/base.component';
import { ddados } from '../imprimirSolicitacao.ddados';
import autobind from 'react-autobind';
import RedeSIMForm from '../../redeSIM.form';
import imprimirSolicitacaoSelector from '../store/imprimirSolicitacao.selectors';
import imprimirSolicitacaoActions from '../store/imprimirSolicitacao.actions';
import PesquisaProtocoloModal from './imprimirSolicitacao.modal';
import ImprimirSolicitacaoGridPesquisa from './imprimirSolicitacao.gridPesquisa';

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  verifyCallback(response) {
    this.props.imprimirSolicitacaoActions.setTokenRecaptcha(response);
  }

  expiredCallback() {
    this.props.imprimirSolicitacaoActions.setTokenRecaptcha('');
  }

  recaptchaRef(ref) {
    this.props.imprimirSolicitacaoActions.setRecaptchaResetRef(ref?.reset);
  }

  onSubmit(values) {
    this.props.imprimirSolicitacaoActions.pesquisarImprimirSolicitacao(values);
  }

  onSearch() {
    this.props.imprimirSolicitacaoActions.toggleModalImprimirSolicitacao();
  }

  componentDidMount() {}

  render() {
    const { imprimirSolicitacao } = this.props.imprimirSolicitacaoSelector;
    const { GridImprimirSolicitacaoPesquisa, PesquisaProtocoloModalToggle } = imprimirSolicitacao;

    const gridPesquisaImprimirSolicitacao = GridImprimirSolicitacaoPesquisa?.length > 0;
    const redeSimForm = !gridPesquisaImprimirSolicitacao;

    return (
      <>
        <PesquisaProtocoloModal show={PesquisaProtocoloModalToggle} />

        {gridPesquisaImprimirSolicitacao && <ImprimirSolicitacaoGridPesquisa />}

        {redeSimForm && (
          <RedeSIMForm
            title={ddados.Titulo}
            recaptchaRef={this.recaptchaRef}
            verifyCallback={this.verifyCallback}
            expiredCallback={this.expiredCallback}
            onSubmit={this.onSubmit}
            onSearch={this.onSearch}
            isView
          />
        )}
      </>
    );
  }
}

export default connect({
  actions: {
    imprimirSolicitacaoActions,
  },
  selectors: {
    imprimirSolicitacaoSelector,
  },
})(Container);
